// Dependencies
import { FC, SVGProps } from "react";
import { useSnackbar } from "notistack";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";

// apis
import { logout } from "~/services/auth";

// Routes
import config from "~/config";

// Types
import { TQueryError } from "~/types";

// Styles
import {
  StyledMenuIcon,
  StyledMenuLabel,
  StyledLogoutMenu,
} from "./SideMenu.styled";

interface LogoutMenuProps {
  Icon: FC<SVGProps<SVGSVGElement>>;
  label: string;
}

const LogoutMenu: FC<LogoutMenuProps> = ({ Icon, label }) => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const logoutMutation = useMutation({
    mutationFn: logout,
    onSuccess() {
      enqueueSnackbar("Logout success!", { variant: "success" });
      navigate(config.routes.login);
    },
    onError(error: TQueryError) {
      enqueueSnackbar(error.message, { variant: "error" });
    },
  });

  const handleLogout = () => {
    logoutMutation.mutate();
  };

  return (
    <StyledLogoutMenu onClick={handleLogout}>
      <StyledMenuIcon>
        <Icon />
      </StyledMenuIcon>
      <StyledMenuLabel>{label}</StyledMenuLabel>
    </StyledLogoutMenu>
  );
};

export default LogoutMenu;
